// Cart bundle nudge popup
(function () {
  var POPUP_ID = 'mf-bundle-popup-overlay';
  var TRIGGER_SEL = '.mf-bundle-nudge-trigger';
  var dismissed = false;

  function getOrCreatePopup() {
    var existing = document.getElementById(POPUP_ID);
    if (existing) return existing;
    var overlay = document.createElement('div');
    overlay.id = POPUP_ID;
    overlay.className = 'mf-bundle-popup-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Bundle offer');
    overlay.innerHTML =
      '<div class="mf-bundle-popup">' +
        '<button class="mf-bundle-popup__close" aria-label="Close">' +
          '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M6 6L14 14M6 14L14 6" stroke="#475359" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</button>' +
        '<div class="mf-bundle-popup__image-col">' +
          '<img src="https://cdn.shopify.com/s/files/1/0435/6698/9476/files/251022_Notebooks-Autumn-Set.jpg?v=1762372401" alt="Classic Notebook bundle" class="mf-bundle-popup__image">' +
        '</div>' +
        '<div class="mf-bundle-popup__content">' +
          '<p class="mf-bundle-popup__heading">Complete your bundle</p>' +
          '<p class="mf-bundle-popup__message">You have 2 Classic Notebooks in your basket. Would you like to add one more and save £9?</p>' +
          '<button class="mf-bundle-popup__learn-more" aria-expanded="false">Learn more about our bundles</button>' +
          '<ul class="mf-bundle-popup__details">' +
            '<li>Save 10% compared to purchasing single notebooks</li>' +
            '<li>Pay 3x lower shipping fees</li>' +
            '<li>Consume 3x less packaging and fewer carbon miles</li>' +
            '<li>Enjoy the convenience of having notebooks waiting on your shelf</li>' +
          '</ul>' +
          '<div class="mf-bundle-popup__actions">' +
            '<a href="https://markandfold.com/collections/classic-notebooks" class="mf-bundle-popup__btn mf-bundle-popup__btn--yes">Yes</a>' +
            '<button class="mf-bundle-popup__btn mf-bundle-popup__btn--no">No thanks</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    overlay.querySelector('.mf-bundle-popup__close').addEventListener('click', dismissPopup);
    overlay.querySelector('.mf-bundle-popup__btn--no').addEventListener('click', dismissPopup);
    overlay.querySelector('.mf-bundle-popup__learn-more').addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      overlay.querySelector('.mf-bundle-popup__details').classList.toggle('is-open', !expanded);
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) dismissPopup();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dismissPopup();
    });
    return overlay;
  }

  function dismissPopup() {
    var overlay = document.getElementById(POPUP_ID);
    if (overlay) overlay.classList.remove('is-open');
    dismissed = true;
  }

  function checkBundleNudge() {
    var hasTrigger = !!document.querySelector(TRIGGER_SEL);
    if (hasTrigger && !dismissed) {
      getOrCreatePopup().classList.add('is-open');
    } else if (!hasTrigger) {
      var overlay = document.getElementById(POPUP_ID);
      if (overlay) overlay.classList.remove('is-open');
      dismissed = false;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    checkBundleNudge();

    var cartTotals = document.querySelector('[data-cart-totals]');
    if (cartTotals) {
      new MutationObserver(checkBundleNudge).observe(cartTotals, {
        childList: true,
        subtree: true
      });
    }
  });
})();

// MF FAQ — snippets/mf-faq.liquid intentionally has no JS here. It reuses
// the stock "pxs-faq" module already bundled in startup.js (same one that
// drives /pages/help) via a data-section-type="pxs-faq" marker, so it gets
// identical open/close animation for free. See snippets/mf-faq.liquid.
